import { connect } from "react-redux";
import FilterSection from "./FilterSection";
import { fetchSurveysFromTheOrg, getCantAnswerResponses, getDevAndStrengthVisualization, getRaterHeatmap, getTopStrengthTopDev, getTotalFeedbackProviders, handleChangeBenchmarkFilter } from "../../../../../../redux/actions";


const mapStateToProps = (state) => ({
    benchmarkFiltersAnalysis: state.BenchmarkFilteringReducer.benchmarkFiltersAnalysis,
    fetchSurveyLists: state.BenchmarkFilteringReducer.fetchSurveyLists,
    isVisualizationDataFectched: state.BenchmarkFilteringReducer.isVisualizationDataFectched,
    isSurveyListFetched: state.BenchmarkFilteringReducer.isSurveyListFetched


});

const mapDispatchToProps = (dispatch) => ({
    handleChangeBenchmarkFilter: (payload) => dispatch(handleChangeBenchmarkFilter(payload)),
    getCantAnswerResponses: (payload) => dispatch(getCantAnswerResponses(payload)),
    getDevAndStrengthVisualization: (payload) => dispatch(getDevAndStrengthVisualization(payload)),
    getTopStrengthTopDev: (payload) => dispatch(getTopStrengthTopDev(payload)),
    getTotalFeedbackProviders: (payload) => dispatch(getTotalFeedbackProviders(payload)),
    fetchSurveysFromTheOrg: (payload) => dispatch(fetchSurveysFromTheOrg(payload)),
    getRaterHeatmap: (payload) => dispatch(getRaterHeatmap(payload))



});

export default connect(mapStateToProps, mapDispatchToProps)(FilterSection);
